import ReactStrapTable from "components/reactStrapTable";
import useAxios from "hooks/useAxios";
import { cloneDeep, result } from "lodash";
import React, { useState, useEffect } from "react";
import { cellRendererCheck, currencyFormat, dateFormate } from "utils/columns";


const SbSummaryTable = (props) => {
    const API = useAxios();
    const { reportType, summeryData, orgId, search, filters, onDataChange,   onDataChange1,
        onSearchColumnFilters = () => '', refetch, totalItem, onPageChange,collapseSider,
    toggleSider,pharmaData,Rowdata,resetFilterFlag,
        SetResetFilterFlag,key } = props;

    const [state, updateState] = useState({
        tableData: [],
        backUpData: [],
        filters: filters,
    });
    useEffect(() => {
        setState({ tableData: summeryData, backUpData: summeryData });
    }, [summeryData]);
    const setState = (obj) => updateState(pre => ({ ...pre, ...obj }));
     const [columnFilters, setColumnFilters] = useState([]);
    useEffect(() => {
        setState({ filters: filters });
    }, [filters]);
    const reasons=[
        {id:1,label:"reason1"},
        {id:2,label:"reason2"},
        {id:3,label:"reason3"},
        {id:4,label:"reason4"}

    ]
    const reasonarray=reasons.map((item)=>item.label)
    const joinedNames = reasonarray.join("/");



    let wacimpactreport = [
        {
            dataField: 'options',
            text: 'Options',
            sort: false,
            width: 80,
            show: true,
            hidecolFilter: true,
            action: true,
            inputType: 'text',

        },
        {
            dataField: 'coveredEntity',
            text: 'Covered Entity',
            sort: true,
            width: 180,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.coveredEntity),
            showColumn: true
        },
        {
            dataField: 'accumulator',
            text: 'Accumulator',
            sort: true,
            width: 180,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.accumulator),
            showColumn: true
        },
        {
            dataField: 'hospitalName',
            text: 'Hospital Name',
            sort: true,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.hospitalName),
            showColumn: true
        },
        {
            dataField: 'wholesaler',
            text: 'Wholesaler',
            sort: true,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.wholesaler),
            showColumn: true
        },
        {
            dataField: 'accountType',
            text: 'Account Type ',
            sort: false,
            width: 80,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.accountType),
            showColumn: true
        },
        {
            dataField: 'accountNumber',
            text: 'Account #',
            sort: false,
            width: 80,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.accountNumber),
            showColumn: true
        },
        {
            dataField: 'totalSpend',
            text: 'Total Spend',
            sort: false,
            width: 80,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.totalSpend),
            showColumn: true
        },
        {
            dataField: 'totalSavings340B',
            text: '340B Total Savings',
            sort: false,
            width: 80,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.totalSavings340B),
            showColumn: true
        },
        {
            dataField: 'wacImpact',
            text: 'WACImpact',
            sort: false,
            width: 80,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.wacImpact),
            showColumn: true
        },
        {
            dataField: 'netSavings',
            text: 'NetSavings',
            sort: false,
            width: 80,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.netSavings),
            showColumn: true
        },
        // {
        //     dataField: 'reason',
        //     text: 'Reason',
        //     sort: false,
        //     width: 80,
        //     show: reportType=="utilizationData"?false:"true",
        //     inputType: 'text',
        //     hideColFilter: true,
        //     cellRenderer: (rowData, col) => cellRenderReasonDetails(rowData),
        //     showColumn: true
        // },
        // {
        //     dataField: 'utilizationCount',
        //     text: 'Utilization Count',
        //     sort: true,
        //     width: 100,
        //     show: true,
        //     inputType: 'text',
        //     hideColFilter: false,
        //     cellRenderer: (rowData, col) => cellRendererCheck(rowData.utilizationCount),
        //     showColumn: true
        // },

    ]
    let utilizationcoloums = [
        {
            dataField: 'options',
            text: 'Options',
            sort: false,
            width: "10%",
            show: true,
            hidecolFilter: true,
            action: true,
            inputType: 'text',

        },
        {
            dataField: 'ceName',
            text: 'Covered Entity/OPAID',
            sort: false,
            width: "25%",
            show: true,
            inputType: 'text',
            hideColFilter: true,
             cellRenderer: (rowData, col) => cellRendererCheck(rowData.ceName),
            showColumn: true
        },
        {
            dataField: 'accumulatorName',
            text: 'Accumulator',
            sort: false,
            width: "25%",
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.accumulatorName),
            showColumn: true
        },
        {
            dataField: 'accountType',
            text: 'Account Type ',
            sort: false,
            width: "20%",
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (rowData, col) =>cellRenderAccountTypeDetails(rowData),
            showColumn: true
        },
        // {
        //     dataField: 'reason',
        //     text: 'Reason',
        //     sort: false,
        //     width: 80,
        //     show: reportType=="utilizationData"?false:"true",
        //     inputType: 'text',
        //     hideColFilter: true,
        //     cellRenderer: (rowData, col) => cellRenderReasonDetails(rowData),
        //     showColumn: true
        // },
        {
            dataField: 'utilizationCount',
            text: 'Utilization Count',
            sort: false,
            width: "20%",
            show: true,
            inputType: 'number',
            hideColFilter: true,
            cellRenderer: (rowData, col) =>cellRendererCheck(rowData.utilizationCount),
            showColumn: true
        },

    ]
    let drugspentcoloums = [
        {
            dataField: 'options',
            text: 'Options',
            sort: false,
            width: 100,
            show: true,
            hidecolFilter: true,
            action: true,
           inputType: 'text',

        },
        {
            dataField: 'ceName',
            text: 'Covered Entity',
            sort: false,
            width: 280,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.ceName ? rowData.ceName : " "),
            showColumn: true
        },
        {
            dataField: 'accumulatorName',
            text: 'Accumulator',
            sort: false,
            width: 280,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.accumulatorName ? rowData.accumulatorName : " "),
            showColumn: true
        },
        {
            dataField: 'groupName',
            text: 'Hospital Name',
            sort: false,
            width: 280,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.groupName ? rowData.groupName : " "),
            showColumn: true
        },
        {
            dataField: 'whosalerName',
            text: 'Wholesaler',
            sort: false,
            width: 200,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.whosalerName ? rowData.whosalerName : " "),
            showColumn: true
        },
        {
            dataField: 'accountType',
            text: 'Account Type',
            sort: false,
            width: 80,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (rowData, col) => cellRenderDrugAccountTypeDetails(rowData),
            showColumn: true
        },
        {
            dataField: 'accuntNumer',
            text: 'Acct #',
            sort: false,
            width: 100,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.accuntNumer ? rowData.accuntNumer:" "),
            showColumn: true
        },
        {
            dataField: 'poStatus',
            text: 'Status',
            sort: false,
            width: 80,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.poStatus ? rowData.poStatus:""),
            showColumn: true
        },
        {
            dataField: 'totalSpent',
            text: 'Total Spend',
            sort: false,
            width: 100,
            show: true,
            inputType: 'number',
            hideColFilter: true,
            cellRenderer: (rowData, col) => rowData.totalSpent !== 0 ? currencyFormat(rowData.totalSpent) : '$0.00',
            showColumn: true
        },
        {
            dataField: 'b340TotalSvaings',
            text: '340B Total Savings',
            sort: false,
            width: 140,
            show: true,
            inputType: 'number',
            hideColFilter: true,
            cellRenderer: (rowData, col) => rowData.b340TotalSvaings !== 0 ? currencyFormat(rowData.b340TotalSvaings) : '$0.00',
            showColumn: true
        },

        {
            dataField: 'wacImpact',
            text: 'WAC Impact',
            sort: false,
            width: 140,
            show: true,
            inputType: 'number',
            hideColFilter: true,
            cellRenderer: (rowData, col) => rowData.wacImpact !== 0 ? currencyFormat(rowData.wacImpact) : '$0.00',
            showColumn: true
        },
        {
            dataField: 'netSavings',
            text: 'Net Savings',
            sort: false,
            width: 100,
            show: true,
            inputType: 'number',
            hideColFilter: true,
            cellRenderer: (rowData, col) => rowData.netSavings !== 0 ? currencyFormat(rowData.netSavings) : '$0.00',
            showColumn: true
        },

    ]

    const rrenderAccountTypeDetails = async (rowData) => {
        debugger;
        let payload = cloneDeep(search);
        payload.Accountype = rowData.accountType == null ?"Pending":rowData.accountType;
        if(rowData.accumulatorId > 0){
        payload.AccumulationIDs = payload.AccumulationIDs.filter(x=>x == rowData.accumulatorId);
        search.AccumulationIDs = payload.AccumulationIDs;
        }
        try {
            const { data } = await API.post(`SBTenant/${orgId.tenantID}/Report/GetAccountTypeHyperLink/`, payload,
                { hasDefaultURL: true, }
            )
            if (data) {
                onDataChange(data,rowData);
                Rowdata(rowData); 
            }
        }
        catch {

        }
    }
    const onReasonType=(data)=>{
        onDataChange1(data);
    };

    const rrenderdrugAccountTypeDetails = async (rowData) => {
       // search.Accountype = rowData.accountType;
       let payload = cloneDeep(search);
        payload.Accountype = rowData.accountType;
       payload.AccuntNumer = rowData.accuntNumer;
       payload.Status = rowData.poStatus;   //SBS-4549
     if(rowData.accumulatorId > 0){
        payload.AccumulationIDs = payload.AccumulationIDs.filter(x=>x == rowData.accumulatorId)
        search.AccumulationIDs = payload.AccumulationIDs;
        }
        try {
            const { data } = await API.post(`SBTenant/${orgId.tenantID}/Report/GetDrugAccountTypeHyperLink/`, payload,
                { hasDefaultURL: true, }
            )
            if (data?.items?.length > 0) {
                onDataChange(data,rowData);
                Rowdata(rowData);
            }
            else{
                data.items=[]
               data.totalRecords = []
               rowData= {};
               onDataChange(data,rowData);
            }
        }
        catch {
           console.log('Error');
        }
    }
    const cellRenderAccountTypeDetails = (rowData) => {
        return (
            <span
                className='text-decoration-underline d-inline-block cursor-pointer'
                onClick={() => rrenderAccountTypeDetails(rowData)}
            >
                {rowData.accountType == null ? "Pending" : rowData.accountType}
            </span>
        );
        // }
    };
    const cellRenderReasonDetails = (rowData) => {
        return (
            <>
                {rowData.accountType == null && (
                    <>
                        <span
                            className='text-decoration-underline d-inline-block cursor-pointer'
                            onClick={() => onReasonType("unmapped-chargecode")}
                        >
                            Provider Not Included/
                        </span>
                        <span
                            className='text-decoration-underline d-inline-block cursor-pointer'
                            onClick={() => onReasonType("location-pending")}
                        >
                            Invalid Effective Date/
                        </span>
                        <span
                            className='text-decoration-underline d-inline-block cursor-pointer'
                            onClick={() => onReasonType("patient-pending")}
                        >
                            Dispensing Quantity Missing OR Not Correct Format/
                        </span>
                        <span
                            className='text-decoration-underline d-inline-block cursor-pointer'
                            onClick={() => onReasonType("hidden-charge")}
                        >
                                 Hidden Charge Code/
                        </span>
                        <span
                            className='text-decoration-underline d-inline-block cursor-pointer'
                            onClick={() => onReasonType("drugadministration")}
                        >
                            Drug Administration Date Not Correct Format/
                        </span>
                        <span
                            className='text-decoration-underline d-inline-block cursor-pointer'
                            onClick={() => onReasonType("dispensingqty")}
                        >
                            Dispensing Quantity Missing OR Not Correct Format/
                        </span>
                        <span
                            className='text-decoration-underline d-inline-block cursor-pointer'
                            onClick={() => onReasonType("grosscharge")}
                        >
                            GrossCharge is Missing OR Not Correct Format
                        </span>
                    </>
                )}
               
            </>
        );
    };
    
    
    const cellRenderDrugAccountTypeDetails = (rowData) => {
        return (
            <span
                className='text-decoration-underline d-inline-block cursor-pointer'
                onClick={() => rrenderdrugAccountTypeDetails(rowData)}
            >
                {rowData.accountType == null ? "Pending" : rowData.accountType == "undefind" ? " " : rowData.accountType}
            </span>
        );
        // }
    };

    const handleSearchColumnFilters = (colFilter) => {
      debugger;
      const filterObj = cloneDeep(search);
      if (onSearchColumnFilters) {
        onSearchColumnFilters(colFilter);
        filterObj.filters = [...filterObj.filters, ...colFilter];
        setColumnFilters(colFilter);
      }
    };

    const handleFilterCancel = () => {
        refetch();
    };
    const handleDrugspentExportSummery = async () => {
        debugger;
        const filterObj = cloneDeep(search);
      
        if (columnFilters && columnFilters.length > 0) {
          filterObj.filters = [...filterObj.filters, ...columnFilters];
        }
    
        const { access_token } =
          JSON.parse(localStorage.getItem('pharmaforce')) || {};
    
          var additionalCriteria = {};
          additionalCriteria.IsSelectedColumn = false;
          additionalCriteria.OrgId = orgId.organizationID;
           // additionalCriteria.ContractId = 0;
        // additionalCriteria.POId = 0;
        // additionalCriteria.OpaId = 0;
        // additionalCriteria.CEId = 0;
        // additionalCriteria.ManufactureId = 0;
    
        var payload = {};
        payload.tenantID = orgId.tenantID
        payload.gridCode = "reportDrugspendsummery";
        payload.fileTypeCode = "csv";
        payload.criteria = JSON.stringify(filterObj);
        payload.additionalCriteria = JSON.stringify(additionalCriteria);
        const { data } = await API.post(`export/queue`, payload, {
          hasExport: true,
        });
      //  const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${orgId.tenantID}/Reports/ExportManufacturerAlls?access_token=${access_token}`;
      //  onExport(action, initialFilters);
      };
      const handleUtilizationExportSummery = async () => {
        debugger;
        const filterObj = cloneDeep(search);
   
        if (columnFilters && columnFilters.length > 0) {
          filterObj.filters = [...filterObj.filters, ...columnFilters];
        }
    
        const { access_token } =
          JSON.parse(localStorage.getItem('pharmaforce')) || {};
    
          var additionalCriteria = {};
          additionalCriteria.IsSelectedColumn = false;
          additionalCriteria.OrgId = orgId.organizationID;
           // additionalCriteria.ContractId = 0;
        // additionalCriteria.POId = 0;
        // additionalCriteria.OpaId = 0;
        // additionalCriteria.CEId = 0;
        // additionalCriteria.ManufactureId = 0;
    
        var payload = {};
        payload.tenantID = orgId.tenantID
        payload.gridCode = "reportUtilizationsummery";
        payload.fileTypeCode = "csv";
        payload.criteria = JSON.stringify(filterObj);
        payload.additionalCriteria = JSON.stringify(additionalCriteria);
        const { data } = await API.post(`export/queue`, payload, {
          hasExport: true,
        });
      //  const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${orgId.tenantID}/Reports/ExportManufacturerAlls?access_token=${access_token}`;
      //  onExport(action, initialFilters);
      };
    const handleSort = (filter, hasColFilter) => {
        debugger;
        setState({
            filters: filter,
        });
        if (hasColFilter) {
            onPageChange(filter, true);
        }
        else {
            onPageChange(filter, false);
        };
    };
    const { filters: colFilter, backUpData } = state;

    if (reportType == "Drupspendbyaccount") {
        return (

            <div
                className='table-card scroll-table position-relative border-0 rounded pt-0'
                fixed-height={backUpData.length > 0 ? 'fixed-height' : 'default'}
            >
                <ReactStrapTable
                keytab={key}
                    id='reportsummery-table'
                    data={backUpData}
                    columns={drugspentcoloums}
                    fixedColumn
                    display={true}
                    //hasPagination
                    pageSize={filters.pageSize}
                    currentPage={filters.currentPage}
                    filters={filters}
                    handleSort={handleSort}
                     hidefilter={true}
                    //totalRecords={totalItem}
                    onExport={handleDrugspentExportSummery}
                    onSearchColumnFilters={handleSearchColumnFilters}
                    onFilterCancel={handleFilterCancel}
                    collapseSider={collapseSider}
          toggleSider={toggleSider}
          showtoggle={true}
          resetFilterFlag={resetFilterFlag}
                SetResetFilterFlag={SetResetFilterFlag}
        // showreportscount={true}

                />
            </div>

        )
    }
    else if(reportType=="Wacimpact"){
        return (

            <div
                className='table-card scroll-table position-relative border-0 rounded pt-0'
                fixed-height={wacimpactreport.length > 0 ? 'fixed-height' : 'default'}
            >
                <ReactStrapTable
                keytab={key}
                    id='reportsummery-utilization-table'
                    data={pharmaData}
                    columns={wacimpactreport}
                    fixedColumn
                    //hasPagination
                    pageSize={filters.pageSize}
                    currentPage={filters.currentPage}
                    filters={filters}
                    handleSort={handleSort}
                    display={true}

                    //totalRecords={totalItem}
                    onExport={handleDrugspentExportSummery}
                    onSearchColumnFilters={handleSearchColumnFilters}
                    onFilterCancel={handleFilterCancel}
                    collapseSider={collapseSider}
          toggleSider={toggleSider}
          showtoggle={true}
          resetFilterFlag={resetFilterFlag}
                SetResetFilterFlag={SetResetFilterFlag}
        // showreportscount={true}

                />
            </div>

        )
    }
    else {
        return (

            <div
                className='table-card scroll-table position-relative border-0 rounded pt-0'
                fixed-height={summeryData.length > 0 ? 'fixed-height' : 'default'}
            >
                <ReactStrapTable
                keytab={key}
                    id='reportsummery-utilization-table'
                    data={summeryData}
                    columns={utilizationcoloums}
                    //hasPagination
                    pageSize={filters.pageSize}
                    currentPage={filters.currentPage}
                    filters={filters}
                    hidefilter={true}
                    fixedColumn
                    display={true}
                    onExport={handleUtilizationExportSummery}
                    handleSort={handleSort}
                    onSearchColumnFilters={handleSearchColumnFilters}
                    onFilterCancel={handleFilterCancel}
                    collapseSider={collapseSider}
          toggleSider={toggleSider}
          showtoggle={true}
          resetFilterFlag={resetFilterFlag}
                SetResetFilterFlag={SetResetFilterFlag}
           />
                    
            </div>

        )
    }
}
export default SbSummaryTable;